import MainLayout from '@/components/layouts'
import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import { type MenuItem, MenuItemHRM } from '@/routes/MenuItem'
import ROUTER from '@/routes/ROUTER'
import { useRouterContext } from '@/shared/context'
import type { TabLogin } from '@/shared/types'
import { STORAGE, storage } from '@/shared/utils/storage'
import { hasPermission } from '@/shared/utils/utils'
import { Result } from 'antd'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, Navigate, Outlet, useLocation } from 'react-router-dom'

export const setShowListMenu = (list: MenuItem[], listTab: TabLogin[]): MenuItem[] =>
  list
    .filter((x) => hasPermission(x?.tabid, listTab))
    .map((i) => ({
      ...i,
      children: i.children ? setShowListMenu(i.children, listTab) : undefined,
    }))
function HrmRoutes() {
  const { setRouterBefore } = useRouterContext()

  // const { listTab } = useListTab()
  // const { listTabs, userInfo } = useSelector((state: any) => state?.appGlobal)
  const { listTabs } = useSelector((state: any) => state?.appGlobal)
  const [menuHrm, setMenuHrm] = useState<MenuItem[]>([])
  const isLogin = storage.getLocalStorage(STORAGE.TOKEN)
  const location = useLocation()
  useEffect(() => {
    const returnUrl = `${location.pathname}${location.search}${location.hash}`
    storage.setReturnUrl(returnUrl)
    if (!isLogin) {
      setRouterBefore(returnUrl)
    }
  }, [isLogin, location, setRouterBefore])

  // Debug
  useEffect(() => {
    if (isLogin) {
      const rootMenu = MenuItemHRM()
      // console.log("1. Danh sách menu gốc:", rootMenu);
      // console.log("2. Quyền hiện tại của User (listTab):", listTabs);

      const menu = setShowListMenu(rootMenu, listTabs)
      // console.log("3. Menu sau khi lọc:", menu);

      setMenuHrm(menu)
    }
  }, [isLogin, listTabs])
  return isLogin ? (
    <div style={{ maxWidth: '100%', maxHeight: '100vh', overflowX: 'hidden' }}>
      {menuHrm?.length > 0 ? (
        <MainLayout type="hrm">
          <Outlet />
        </MainLayout>
      ) : (
        <Result
          status="403"
          title="403 Error Permission"
          subTitle="Xin lỗi, Bạn không có quyền truy cập trang web."
          extra={
            <NavLink to={ROUTER.DEFAULT}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ButtonCustom className="btn-hover-shadow">Quay lại trang chủ</ButtonCustom>
              </div>
            </NavLink>
          }
        />
      )}
    </div>
  ) : (
    <Navigate to={ROUTER.HOME} />
  )
}

export default HrmRoutes
